import { render, staticRenderFns } from "./SubCategoriesAdmin.vue?vue&type=template&id=f42ec7a4&"
import script from "./SubCategoriesAdmin.vue?vue&type=script&lang=js&"
export * from "./SubCategoriesAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports